import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#DFE8F9",
      d: "M11.8 5.5h9.32c.19 0 .36.08.49.21 1.63 1.84 3.37 3.59 5.01 5.43.17.19.37.37.39.63V26.6c-.13 1.79-1.57 3.29-3.35 3.36H11.83c-1.86-.11-3.24-1.64-3.34-3.51V9.03c.08-1.87 1.44-3.41 3.3-3.53z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#2B63D9",
      d: "M6 25.12V6.87c0-2.113 1.646-3.88 3.75-3.88h9.87l.077.004a.75.75 0 0 1 .47.234l5.63 6.01c.13.138.203.322.203.512v15.37c0 2.114-1.646 3.88-3.75 3.88H9.75C7.646 29 6 27.234 6 25.12m1.5 0c0 1.346 1.034 2.38 2.25 2.38h12.5c1.216 0 2.25-1.033 2.25-2.38V10.046L19.295 4.49H9.75c-1.216 0-2.25 1.034-2.25 2.38z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#2B63D9",
      d: "M18 7.51V3.96a.75.75 0 0 1 1.5 0v3.55c0 1.462 1.024 2.48 2.08 2.48h3.54a.75.75 0 0 1 0 1.5h-3.54c-2.064 0-3.58-1.882-3.58-3.98"
    }, null, -1)
  ]))]))
}
export default { render: render }